import login from "./login"; // login

const router = [...login];
export default router;



// WEBPACK FOOTER //
// ./src/router/indexEmpty.js